<template>
    <div>
        <div class="col-12 override-padding mt-2" v-for="(user_type, index) in user_types" :key="index">
            <div class="crm_admin_heading user_header user_heading_1 text-left" v-b-tooltip.hover>
                <span class="user_type_title">{{ user_type.text }}</span>
            </div>
            <div class="crm_admin_heading user_header user_heading_4 text-left" v-b-tooltip.hover>
                Date Added 
            </div>
            <div class="crm_admin_heading user_header user_heading_5 text-left" v-b-tooltip.hover>
                &nbsp;&nbsp;
            </div>
            <div style="clear: both;"></div>
            <!-- Users list start -->
            <div v-if="getTotalUsers(user_type.value)">
                <div class="row">
                    <div class="col-1">&nbsp;&nbsp;&nbsp;</div>
                    <div class="col-11">
                        <div v-for="(item, mindex) in account_users[user_type.value]" :key="mindex">
                            <div class="crm_admin_field_lists users_row user_content_1 text-left">
                                {{ item.firstName + ' ' + item.lastName  }}
                            </div>
                            <div class="crm_admin_field_lists users_row user_content_4 text-left">
                                {{ item.createdAt | formatAddedDate }}
                            </div>
                            <div :class="'crm_admin_field_lists users_row user_content_5 text-center font-weight-bold ' + getStatusColor(item.userStatus)">
                                {{ item.userStatus }}
                            </div>
                            <hr class="users_hr" v-if="mindex == account_users[user_type.value].length">
                            <div style="clear: both;"></div>
                        </div>
                    </div>
                </div>
                <div style="clear: both;"></div>
            </div>
            <div v-else>
                <div class="col-12 text-center text-danger">No {{ user_type.text }} Found</div>
            </div>
        </div>
    <!-- Users list end -->
    <hr class="users_hr">
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import moment from 'moment';

Vue.filter('formatAddedDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});

export default {
    data(){
        return{
          user_types: [{ text: 'Mentees', value: 'mentee'}, { text: 'Apprentices', value: 'apprentice'}],
          account_users: [],
          total_users: 0,
        }
    },
    components: {
    },
    methods: {
        getStatusColor(status) {
            if (status == "Active") {
                return 'text_green';
            } else if(status == "Inactive") {
                return 'text_red';
            } else {
                return '';
            }
        },
        getAccountUsers(accountId) {
            axios.get('/enterprise/account-user-list/' + accountId, {

            })
            .then(response =>  {
              this.account_users = response.data.users;
              this.total_users = response.data.total_users;
            })
            .catch(function(error) {

            });
        },
        getTotalUsers(user_type) {
            if (this.total_users > 0) {
                if (this.account_users[user_type].length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    },
}
</script>
<style scoped>
/* Users css start */
.user_heading_1 { width: 82%; }
.user_heading_2 { width: 10%; }
.user_heading_3 { width: 27%; }
.user_heading_4 { width: 13%; }
.user_heading_5 { width: 5%; }

.user_content_1 { width: 81%; }
.user_content_2 { width: 11%; }
.user_content_3 { width: 30%; }
.user_content_4 { width: 9%; }
.user_content_5 { width: 10%; }

.user_type_title { margin-left: 2.3rem; }
.link_name, .link_name:focus { color: #00ACEE !important; text-decoration: none; cursor: pointer; }
.user_header {
  background: #707070 none repeat scroll 0 0 !important;
  border-bottom: 2px solid #ddd;
  border-top: 0 none;
  color: #fff;
  float: left;
  line-height: 1.42857;
  padding: 8px 3px;
  vertical-align: bottom;
}
.text_green {
    color: #4ea959 !important;
}
.text_red {
    color: #ff0000 !important;
}
.users_row {
  border-bottom: 1px solid #00ACEE;
  padding: 5px 0px;
}
.users_hr {
  margin: 30px 0px;
  border-bottom: 2px solid #00ACEE;
}
@media (max-width: 768px) {
  .user_header {
    padding: 8px 1px;
    font-size: 11px;
  }
}

.no_user_header {
  background: #FFFFFF none repeat scroll 0 0 !important;
  border-bottom: 2px solid #ddd;
  border-top: 0 none;
  color: #FF0000;
  float: left;
  line-height: 1.42857;
  padding: 8px 3px;
  vertical-align: bottom;
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}
/* Users css end */
</style>


// WEBPACK FOOTER //
// src/components/admin/enterprise_account_user_header.vue